module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.dialogsARR), function(dialog) {
    return _c('dialog-window', {
      key: dialog.id,
      attrs: {
        "options": dialog,
        "escapeKeyClose": dialog.escapeKeyClose
      },
      on: {
        "close": _vm.destroyDialog
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-58f8801b!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugin/components/dialog.vue
// module id = 111
// module chunks = 0